var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 100,
    viewBox: "0 0 1441 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1441,
    height: 99.8763,
    rx: 24,
    fill: "#2C3041"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3789_14695",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1441,
    height: 100
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1441,
    height: 100,
    rx: 24,
    fill: "#6F5CE6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3789_14695)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.12,
    cx: 1073.5,
    cy: 78.5715,
    rx: 578.5,
    ry: 232.488,
    fill: "url(#paint0_radial_3789_14695)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.55,
    cx: 141.5,
    cy: 33.4101,
    rx: 670.5,
    ry: 231.567,
    fill: "url(#paint1_radial_3789_14695)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.55,
    cx: 1283,
    cy: -48.1567,
    rx: 408,
    ry: 191.475,
    fill: "url(#paint2_radial_3789_14695)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3789_14695",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1073.5 147.166) rotate(116.601) scale(183.295 380.695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33C2B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3789_14695",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.973 32.7147) rotate(28.1513) scale(369.953 337.772)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3789_14695",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1235.22 -48.7317) rotate(36.0219) scale(245.411 256.196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportForm);
export default __webpack_public_path__ + "static/media/report-form.16df455a4b74d6151b7bf8c62dbff686.svg";
export { ForwardRef as ReactComponent };